/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'

const SidebarMenuMain = () => {
  const intl = useIntl()

  return (
    <>
      {/* <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      /> */}
     
      {/*<div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Apps</span>
        </div>
      </div>*/}
    
      <SidebarMenuItem
        to='/apps/user-management/users'
        icon='abstract-28'
        title={intl.formatMessage({id: 'Order management'})}
        fontIcon='bi-layers'
        hideTitle
        disableActive
      />
      <SidebarMenuItem
        to='/apps/customer-ordered-products/ordered-products-list'
        icon='basket'
        title={intl.formatMessage({id: 'Previous Orders'})}
        fontIcon='bi-basket'
      />

    </>
  )
}

export {SidebarMenuMain}
